import { type PropsWithChildren, useContext } from 'react';

import { PieChartConfigContext } from '../context/ChartConfigContext.js';
import { PieChartProps, PieDonutConfig } from '../types/pie-chart.config.js';
import { iterateSlots } from '../utils/iterate-slots.js';
import { buildPieChartConfig, deserializeConfig } from '../utils/pie-config.js';

export const usePieChartConfig = (
  props: PropsWithChildren<PieChartProps>,
): PieDonutConfig => {
  const { children } = props;
  const contextConfig = useContext(PieChartConfigContext);
  const slots = iterateSlots(children);

  const isImportedConfig = typeof contextConfig === 'string';
  const config = isImportedConfig
    ? deserializeConfig(contextConfig)
    : contextConfig;

  return buildPieChartConfig(props, config, slots);
};
